/**
 * Move a City Explorer out of page/layout stacking contexts while it is active.
 * The placeholder preserves the original document geometry; the host guarantees
 * the city is a true viewport overlay regardless of transformed/sticky parents.
 */
export function createCityViewportPortal(root) {
    if (!root) return null;

    let placeholder = null;
    let host = null;

    const mount = () => {
        if (host?.isConnected && host.contains(root)) return host;

        const rect = root.getBoundingClientRect();
        placeholder = document.createElement('div');
        placeholder.setAttribute('data-city-portal-placeholder', '');
        placeholder.setAttribute('aria-hidden', 'true');
        placeholder.style.width = '100%';
        placeholder.style.height = `${Math.max(1, rect.height)}px`;
        placeholder.style.pointerEvents = 'none';

        root.parentNode?.insertBefore(placeholder, root);

        host = document.createElement('div');
        host.setAttribute('data-city-portal-host', '');
        document.body.appendChild(host);
        host.appendChild(root);
        root.dataset.cityPortal = 'active';

        return host;
    };

    const restore = () => {
        if (placeholder?.parentNode) {
            placeholder.parentNode.insertBefore(root, placeholder);
            placeholder.remove();
        }

        if (host?.parentNode) host.remove();
        placeholder = null;
        host = null;
        delete root.dataset.cityPortal;
    };

    return {
        mount,
        restore,
        isMounted: () => Boolean(host?.isConnected && host.contains(root)),
    };
}
